define('vspot-angular/services/page-unload-service',[], function () {
    'use strict';

    return [function () {
        var beforeunloadCalled = false;

        window.onbeforeunload = function (e) {
            beforeunloadCalled = true;
        };

        return {
            wasCalled: function () {
                return beforeunloadCalled;
            }
        }
    }];
});

